import { Injectable } from '@angular/core';

@Injectable()
export class ShellUpgradeService {
  private bootstrapped: {
    [key: string]: boolean;
  } = {};

  getBootstrapped(key: string) {
    if (typeof this.bootstrapped[key] !== 'undefined' && this.bootstrapped[key]) {
      return this.bootstrapped[key];
    }

    return false;
  }

  setBootstrapped(key: string, value: boolean = true) {
    this.bootstrapped[key] = value;
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/shell-upgrade.service.ts